import { render, staticRenderFns } from "./subwayrunner.vue?vue&type=template&id=5ffde5f6"
import script from "./subwayrunner.vue?vue&type=script&lang=js"
export * from "./subwayrunner.vue?vue&type=script&lang=js"
import style0 from "./subwayrunner.vue?vue&type=style&index=0&id=5ffde5f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports